import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PatientDTO } from '@core/apis/patient/patient.dto';
import { SubNavbarComponent } from '@core/components/sub-navbar/sub-navbar.component';
import { INavRoute } from '@core/components/sub-navbar/sub-navbar.interface';
import { clinicTypeMeasurementsNavigation } from '@core/constants/measurement-navigation';
import { PatientInRouterService } from '@core/services/patient-in-router.service';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-measurement-dashboard',
  imports: [RouterModule, SubNavbarComponent, TranslocoModule, CommonModule],
  templateUrl: './measurement-dashboard.component.html',
  styleUrl: './measurement-dashboard.component.scss',
})
export class MeasurementDashboardComponent implements OnInit {
  public readonly routes: INavRoute[] = clinicTypeMeasurementsNavigation;
  public patient: PatientDTO | undefined = undefined;

  constructor(private patientInRouterService: PatientInRouterService) {}

  ngOnInit() {
    this.patientInRouterService.getPatientById();
    this.patientInRouterService.patientSubj.subscribe((res: PatientDTO | null) => {
      this.patient = res ? res : undefined;
    });
  }
}
